export enum CUSTOMER_SEARCH_QUERY_PARAM_KEYS {
    GENDER = "gender",
    AGE = "age",
    CERTIFIED = "onboarded",
    LAST_VISIT_RANGE = "last_visit_range"
}
